import React, { Component } from 'react';
import styled from 'styled-components';
import { Form, TextareaInput } from 'forms-core-components';
import { Button } from 'primitive-components';
import { colors } from 'bench-style-constants';

const Wrapper = styled.div`
  padding: 4px;
  border: 1px solid ${colors.clay};
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
  color: ${colors.white};
`;

const StyledTextarea = styled(TextareaInput)`
  width: 100%;
  resize: none;
  border: none;
  border-radius: 2px;

  &:focus {
    outline: none;
  }
`;

type MessageInputBoxProps = {
  onPost: (message: string) => void;
  placeholder?: string;
  submitButtonText?: string;
  isExpanded?: boolean;
  value?: string;
};

type MessageInputBoxState = {
  isExpanded?: boolean;
};

class MessageInputBox extends Component<MessageInputBoxProps, MessageInputBoxState> {
  static defaultProps = {
    placeholder: '',
    submitButtonText: 'Submit',
    isExpanded: false,
    value: '',
  };

  constructor(props: MessageInputBoxProps) {
    super(props);

    const { isExpanded } = props;

    this.state = {
      isExpanded,
    };
  }

  onPost = (formValue: { body: string }) => {
    this.setState({
      isExpanded: false,
    });

    this.props.onPost(formValue.body);
  };

  expandInputBox = () => {
    this.setState({ isExpanded: true });
  };

  render() {
    const { placeholder, submitButtonText, value } = this.props;

    const { isExpanded } = this.state;

    return (
      <Wrapper>
        <Form
          onSubmit={form => {
            this.onPost(form.currentValue);
            form.reset();
          }}
          value={{ body: value || '' }}
          data-test-id="message-input-form"
        >
          <StyledTextarea
            name="body"
            placeholder={placeholder}
            onFocus={this.expandInputBox}
            required
            data-test-id="message-input-box-textarea"
          />
          {isExpanded && (
            <ButtonWrapper>
              <Button styleType="primary" size="small" data-test-id="message-input-box-button">
                {submitButtonText}
              </Button>
            </ButtonWrapper>
          )}
        </Form>
      </Wrapper>
    );
  }
}

export default MessageInputBox;
